import React, { Component } from "react";
import { Row, Col, Form } from "react-bootstrap"
import Select from '../../../Components/PCSelect';

import AmountInput from '../../../Components/AmountInput';
class ShopProfile extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    render() {
        return (
            <>
                <Row>
                    <Col md={6}>
                        <Form.Group className="mb-3" >
                            <Form.Label>Shop Name</Form.Label>
                            <Form.Control
                                value={this.props.SP_NAME}
                                name={"SP_NAME"}
                                onChange={this.props.handleChangeInput.bind(this, "SP_NAME")}
                               
                            />
                        </Form.Group>
                    </Col>
                    {/* <Col md={6}>
                        <Form.Group className="mb-3" >
                            <Form.Label>Link Shop</Form.Label>
                            <Select menuPortalTarget={document.body}
                                menuPlacement="auto"
                                style={{ height: '32px' }}
                                value={this.props.SP_LINKED_SHOP}
                                options={this.props.ShopList.map(x => {
                                    return { value: x.SP_ID, label: x.SP_NAME }
                                })}
                                onChange={this.props.handleChangeInput.bind(this, "SP_LINKED_SHOP")}
                            />
                        </Form.Group>
                    </Col> */}
                </Row>
                <Row>
                    <Col md={12}>
                        <Form.Group className="mb-3" >
                            <Form.Label>Shop Address</Form.Label>
                            <Form.Control
                                value={this.props.SP_ADDRESS}
                                type={"textarea"}
                                name={"SP_ADDRESS"}
                                onChange={this.props.handleChangeInput.bind(this, "SP_ADDRESS")}
                               
                            />
                        </Form.Group>
                    </Col>
                </Row>
                <Row style={{ justifyContent: "space-around", }} >
                    <Col md={3}>
                        <Form.Group className="mb-3" >
                            <Form.Label>Rent Charges</Form.Label>
                            <AmountInput
                                value={this.props.SP_RENT_CHARGES}
                                name={"SP_RENT_CHARGES"}
                                onChange={this.props.handleChangeInput.bind(this, "SP_RENT_CHARGES")}
                               
                            />
                        </Form.Group>
                    </Col>
                    <Col md={3}>
                        <Form.Group className="mb-3" >
                            <Form.Label>K & N Charges</Form.Label>
                            <AmountInput
                                value={this.props.SP_KN_CHARGES}
                                name={"SP_KN_CHARGES"}
                                onChange={this.props.handleChangeInput.bind(this, "SP_KN_CHARGES")}
                               
                            />
                        </Form.Group>
                    </Col>
                    <Col md={3}>
                        <Form.Group className="mb-3" >
                            <Form.Label>NDR Charges</Form.Label>
                            <AmountInput
                                value={this.props.SP_NDR_CHARGES}
                                name={"SP_NDR_CHARGES"}
                                onChange={this.props.handleChangeInput.bind(this, "SP_NDR_CHARGES")}
                               
                            />
                        </Form.Group>
                    </Col>
                    <Col md={3}>
                        <Form.Group className="mb-3" >
                            <Form.Label>Calculation Type</Form.Label>
                            <Form.Control
                                as={"select"}
                                value={this.props.SP_CAL_TYPE}
                                name={"SP_CAL_TYPE"}
                                onChange={this.props.handleChangeInput.bind(this, "SP_CAL_TYPE")}
                               
                            >
                                <option value="">Calculation Type</option>
                                <option value="Cash">Cash Only</option>
                                <option value="Card">Card Only</option>
                                <option value="Both">Both</option>
                            </Form.Control>

                        </Form.Group>
                    </Col>
                </Row>
                {/* <Row style={{ justifyContent: "space-around", }} >
                    <Col md={6}>
                        <Form.Group className="mb-3" >
                            <Form.Label>Shop Manager</Form.Label>
                            <Form.Control
                                value={this.props.SP_MANAGER}
                                name={"SP_MANAGER"}
                                onChange={this.props.handleChangeInput.bind(this, "SP_MANAGER")}
                               
                            />
                        </Form.Group>
                        <Form.Group className="mb-3" >
                            <Form.Label>Shop Manager ID</Form.Label>
                            <Form.Control
                                value={this.props.SP_ID}
                                name={"SP_ID"}
                                onChange={this.props.handleChangeInput.bind(this, "SP_ID")}
                                style={{ width: "100%" }}
                            />
                        </Form.Group>
                    </Col>
                    <Col md={6}>
                        <Form.Group className="mb-3" >
                            <Form.Label>Shop Manager Phone</Form.Label>
                            <Form.Control
                                value={this.props.SP_MANAGER_NUM}
                                name={"SP_MANAGER_NUM"}
                                onChange={this.props.handleChangeInput.bind(this, "SP_MANAGER_NUM")}
                                style={{ width: "100%" }}
                            />
                        </Form.Group>
                    </Col>
                </Row> */}
                <Row>
                    <Col md={12} >

                        <Form.Group className="mb-3" >
                            <Form.Label>Receipt</Form.Label>
                            <Form.Control
                                value={this.props.SP_PRINT_CONTENT}
                                as="textarea"
                                name={"SP_PRINT_CONTENT"}
                                onChange={this.props.handleChangeInput.bind(this, "SP_PRINT_CONTENT")}
                               
                            />
                        </Form.Group>
                    </Col>
                </Row>
            </>
        );
    }
}

export default ShopProfile;